<template>
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 199.11 100.1"
  >
    <g id="Foreground">
      <g>
        <path
          fill="#fe6d0d"
          d="M116.45,56.07c-5.99-9.01-23.9-8.06-33.13-8.36-20.39-.67-40.27,2.32-59.77,7.96-6.93,4.91-13.46,10.41-19.61,16.5,3.68-2.19,10.37-2.49,13.67-3.08,6.83-1.23,13.71-2.18,20.63-2.58,16.16-.92,32.49,1.21,47.93,6.37,15.91,5.32,30.3,14.62,46.17,20.06,7.2,2.46,14.55,4.08,22.03,5.26,5.44.85,17.25,5.11,18.51-2.83-8.1-4.1-16.74-6.66-24.73-11.19-12.22-6.95-23.68-16.02-31.71-28.1Z"
        />
        <path
          fill="#fe6d0d"
          d="M2.13,73.73c1.2-1.65,2.4-3.29,3.6-4.94,2.23-3.06,4.46-6.12,6.72-9.16.26-.35.65-.67,1.04-.81,3.34-1.13,6.7-2.17,10.06-3.15,6.72-4.76,13.8-8.99,21.27-12.61,23.63-11.46,48.23-15.45,73.92-10.25,21.27,4.3,40.13,14.26,57.5,27.62,2.3,1.77,4.56,3.6,6.84,5.41.14-.18.27-.35.4-.53-15.21-23.05-35.14-40.15-59.42-51.62C97.19.99,69-2.16,39.93,1.32c.35.31.74.47,1.14.56,4.24.95,8.55,1.67,12.72,2.89,5.64,1.64,11.22,3.53,16.75,5.57,1.89.7,3.53,2.16,5.39,3.35-.54.57-.62.71-.75.78-.54.29-1.09.56-1.64.84-20.07,10.05-39.46,21.26-56.44,36.58-5.75,5.19-10.95,10.93-14.68,17.95-.93,1.75-1.62,3.65-2.42,5.48.85-.11,1.24-.48,1.61-.86.77-.79,1.56-1.54,2.33-2.31-.74.44-1.37.95-1.81,1.56Z"
        />
        <path
          fill="#fe6d0d"
          d="M13.49,58.82c-.39.13-.79.46-1.04.81-2.26,3.04-4.48,6.1-6.72,9.16-1.2,1.65-2.4,3.3-3.6,4.94.44-.61,1.07-1.12,1.81-1.56,6.15-6.09,12.69-11.59,19.61-16.5-3.36.97-6.72,2.02-10.06,3.15Z"
        />
        <path
          fill="#fe6d0d"
          d="M198.4,57.71c-5.83,4.95-12.26,8.76-19.33,11.37-10.35,3.81-20.83,4.45-31.41,1.19-8.76-2.7-16.31-7.68-23.09-14.02-.9-.84-1.78-1.71-2.67-2.56-.06.07-.13.14-.19.21,5.51,10.32,13.23,18.33,22.98,24.17,10.8,6.46,22.52,8.97,34.85,8.73-.13-.14-.29-.23-.46-.28-1.74-.58-3.52-1.06-5.23-1.75-2.31-.92-4.58-1.96-6.82-3.04-.77-.37-1.4-1.06-2.14-1.64.25-.22.29-.27.34-.29.24-.1.48-.19.72-.28,8.8-3.37,17.37-7.26,25.08-12.98,2.61-1.94,5.01-4.12,6.84-6.92.46-.7.82-1.46,1.22-2.2-.36.01-.54.15-.71.29Z"
        />
      </g>
    </g>
  </svg>
</template>
